// services/ai.js
import axiosInstance from './axiosInstance';

const AI_API_URL = '/AI';

const aiService = {
  async parseInvoice(formData) {
    try {
      // O axios automaticamente detecta FormData e define o Content-Type correto
      // incluindo o boundary necessário para multipart/form-data
      const response = await axiosInstance.post(`${AI_API_URL}/gemini/invoiceParser.php`, formData);
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer parse da fatura:', error);
      throw error;
    }
  },

  async fetchBestImageWithAI(idempresa, idproduct) {
    try {
      const response = await axiosInstance.get(`${AI_API_URL}/gemini/productImage.php?idempresa=${idempresa}&idproduct=${idproduct}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar melhor imagem com IA:', error);
      throw error;
    }
  },
};

export default aiService;
